// extracted by mini-css-extract-plugin
export default {"barbarianInvasionTrackerContainer":"barbarianInvasionTrackerContainer-iC5oSlLu"};